<div class="closing-x-wrap">
    <mat-icon class="close-icon condenced" alt="Close dialog" (click)="close()"> close </mat-icon>
</div>
<h1 mat-dialog-title id="signature-title">{{ title }}</h1>
<div mat-dialog-content>
    <profile-info-form-component
        [profileFormProperties]="userInfo"
        [allowExistingUser]="allowExistingUser"
        [offLimitsUserIds]="offLimitsUserIds"
        (outEvent)="closeModal($event)"
    >
    </profile-info-form-component>
</div>
